import { render, staticRenderFns } from "./DisponibilitaList.vue?vue&type=template&id=4f37f59f"
import script from "./DisponibilitaList.vue?vue&type=script&lang=js"
export * from "./DisponibilitaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports